module.exports = __webpack_public_path__ + "static/img/watch1.1f36b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/watch1.png
// module id = pdtS
// module chunks = 8